import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const VUEX_PROPERTIES = ['state', 'getters', 'actions', 'mutations']

let store = {};

(function updateModules () {
  store = normalizeRoot(require('../store/index.ts'), 'store/index.ts')

  // If store is an exported method = classic mode (deprecated)

  // Enforce store modules
  store.modules = store.modules || {}

  resolveStoreModules(require('../store/apis/AbilityTest.ts'), 'apis/AbilityTest.ts')
  resolveStoreModules(require('../store/apis/AkamaiToken.ts'), 'apis/AkamaiToken.ts')
  resolveStoreModules(require('../store/apis/AnalysisReport.ts'), 'apis/AnalysisReport.ts')
  resolveStoreModules(require('../store/apis/Answer.ts'), 'apis/Answer.ts')
  resolveStoreModules(require('../store/apis/AssignmentTest.ts'), 'apis/AssignmentTest.ts')
  resolveStoreModules(require('../store/apis/ATR.ts'), 'apis/ATR.ts')
  resolveStoreModules(require('../store/apis/Calendar.ts'), 'apis/Calendar.ts')
  resolveStoreModules(require('../store/apis/ChrMessage.ts'), 'apis/ChrMessage.ts')
  resolveStoreModules(require('../store/apis/CmsToken.ts'), 'apis/CmsToken.ts')
  resolveStoreModules(require('../store/apis/ContractCoursePlan.ts'), 'apis/ContractCoursePlan.ts')
  resolveStoreModules(require('../store/apis/ContractInformation.ts'), 'apis/ContractInformation.ts')
  resolveStoreModules(require('../store/apis/Contractors.ts'), 'apis/Contractors.ts')
  resolveStoreModules(require('../store/apis/DetermineSchool.ts'), 'apis/DetermineSchool.ts')
  resolveStoreModules(require('../store/apis/DetermineSchoolRanking.ts'), 'apis/DetermineSchoolRanking.ts')
  resolveStoreModules(require('../store/apis/DetermineSchoolSubject.ts'), 'apis/DetermineSchoolSubject.ts')
  resolveStoreModules(require('../store/apis/DiagnoseSchool.ts'), 'apis/DiagnoseSchool.ts')
  resolveStoreModules(require('../store/apis/diagnoseSchoolRanking.ts'), 'apis/diagnoseSchoolRanking.ts')
  resolveStoreModules(require('../store/apis/DiagnoseSchoolSubject.ts'), 'apis/DiagnoseSchoolSubject.ts')
  resolveStoreModules(require('../store/apis/FetchRevision.ts'), 'apis/FetchRevision.ts')
  resolveStoreModules(require('../store/apis/FixationLevel.ts'), 'apis/FixationLevel.ts')
  resolveStoreModules(require('../store/apis/FullDigital.ts'), 'apis/FullDigital.ts')
  resolveStoreModules(require('../store/apis/FullDigitalTeishutsu.ts'), 'apis/FullDigitalTeishutsu.ts')
  resolveStoreModules(require('../store/apis/IdToken.ts'), 'apis/IdToken.ts')
  resolveStoreModules(require('../store/apis/Lab.ts'), 'apis/Lab.ts')
  resolveStoreModules(require('../store/apis/Learn.ts'), 'apis/Learn.ts')
  resolveStoreModules(require('../store/apis/LoginHistory.ts'), 'apis/LoginHistory.ts')
  resolveStoreModules(require('../store/apis/MemberName.ts'), 'apis/MemberName.ts')
  resolveStoreModules(require('../store/apis/Monthlist.ts'), 'apis/Monthlist.ts')
  resolveStoreModules(require('../store/apis/MonthlyCheck.ts'), 'apis/MonthlyCheck.ts')
  resolveStoreModules(require('../store/apis/MonthlyTest.ts'), 'apis/MonthlyTest.ts')
  resolveStoreModules(require('../store/apis/NewNotices.ts'), 'apis/NewNotices.ts')
  resolveStoreModules(require('../store/apis/Notices.ts'), 'apis/Notices.ts')
  resolveStoreModules(require('../store/apis/OnlineSpeakingSSO.ts'), 'apis/OnlineSpeakingSSO.ts')
  resolveStoreModules(require('../store/apis/OnlineSpeakingSSOOneTimeKey.ts'), 'apis/OnlineSpeakingSSOOneTimeKey.ts')
  resolveStoreModules(require('../store/apis/Puchipo.ts'), 'apis/Puchipo.ts')
  resolveStoreModules(require('../store/apis/Result.ts'), 'apis/Result.ts')
  resolveStoreModules(require('../store/apis/ReviewContentListModal.ts'), 'apis/ReviewContentListModal.ts')
  resolveStoreModules(require('../store/apis/Sample.ts'), 'apis/Sample.ts')
  resolveStoreModules(require('../store/apis/ScheduleForThisMonth.ts'), 'apis/ScheduleForThisMonth.ts')
  resolveStoreModules(require('../store/apis/schoolOfChoice.ts'), 'apis/schoolOfChoice.ts')
  resolveStoreModules(require('../store/apis/TopContent.ts'), 'apis/TopContent.ts')
  resolveStoreModules(require('../store/apis/Unit.ts'), 'apis/Unit.ts')
  resolveStoreModules(require('../store/apis/Viewer.ts'), 'apis/Viewer.ts')
  resolveStoreModules(require('../store/pages/Learn.ts'), 'pages/Learn.ts')

  // If the environment supports hot reloading...
})()

// createStore
export const createStore = store instanceof Function ? store : () => {
  return new Vuex.Store(Object.assign({
    strict: (process.env.NODE_ENV !== 'production')
  }, store))
}

function normalizeRoot (moduleData, filePath) {
  moduleData = moduleData.default || moduleData

  if (moduleData.commit) {
    throw new Error(`[nuxt] ${filePath} should export a method that returns a Vuex instance.`)
  }

  if (typeof moduleData !== 'function') {
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData)
  }
  return normalizeModule(moduleData, filePath)
}

function normalizeModule (moduleData, filePath) {
  if (moduleData.state && typeof moduleData.state !== 'function') {
    console.warn(`'state' should be a method that returns an object in ${filePath}`)

    const state = Object.assign({}, moduleData.state)
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData, { state: () => state })
  }
  return moduleData
}

function resolveStoreModules (moduleData, filename) {
  moduleData = moduleData.default || moduleData
  // Remove store src + extension (./foo/index.js -> foo/index)
  const namespace = filename.replace(/\.(js|mjs|ts)$/, '')
  const namespaces = namespace.split('/')
  let moduleName = namespaces[namespaces.length - 1]
  const filePath = `store/${filename}`

  moduleData = moduleName === 'state'
    ? normalizeState(moduleData, filePath)
    : normalizeModule(moduleData, filePath)

  // If src is a known Vuex property
  if (VUEX_PROPERTIES.includes(moduleName)) {
    const property = moduleName
    const propertyStoreModule = getStoreModule(store, namespaces, { isProperty: true })

    // Replace state since it's a function
    mergeProperty(propertyStoreModule, moduleData, property)
    return
  }

  // If file is foo/index.js, it should be saved as foo
  const isIndexModule = (moduleName === 'index')
  if (isIndexModule) {
    namespaces.pop()
    moduleName = namespaces[namespaces.length - 1]
  }

  const storeModule = getStoreModule(store, namespaces)

  for (const property of VUEX_PROPERTIES) {
    mergeProperty(storeModule, moduleData[property], property)
  }

  if (moduleData.namespaced === false) {
    delete storeModule.namespaced
  }
}

function normalizeState (moduleData, filePath) {
  if (typeof moduleData !== 'function') {
    console.warn(`${filePath} should export a method that returns an object`)
    const state = Object.assign({}, moduleData)
    return () => state
  }
  return normalizeModule(moduleData, filePath)
}

function getStoreModule (storeModule, namespaces, { isProperty = false } = {}) {
  // If ./mutations.js
  if (!namespaces.length || (isProperty && namespaces.length === 1)) {
    return storeModule
  }

  const namespace = namespaces.shift()

  storeModule.modules[namespace] = storeModule.modules[namespace] || {}
  storeModule.modules[namespace].namespaced = true
  storeModule.modules[namespace].modules = storeModule.modules[namespace].modules || {}

  return getStoreModule(storeModule.modules[namespace], namespaces, { isProperty })
}

function mergeProperty (storeModule, moduleData, property) {
  if (!moduleData) {
    return
  }

  if (property === 'state') {
    storeModule.state = moduleData || storeModule.state
  } else {
    storeModule[property] = Object.assign({}, storeModule[property], moduleData)
  }
}
